import classNames from 'classnames';
import isBoolean from 'lodash/isBoolean';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import React from 'react';
import { Loading } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import { useMaskData } from '@/layout/hooks';

const MaskLoading: React.FC = () => {
    const maskData = useMaskData();
    const { $t } = useLocaleStore();

    if (!maskData?.isShow) return null;

    const backgroundStyle = isString(maskData.background)
        ? {
              background: maskData.background,
          }
        : {};

    return (
        <div
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            className={classNames('mask-loading-wrap', {
                'mask-background': isBoolean(maskData.background) ? maskData.background : false,
            })}
            style={backgroundStyle}
        >
            <div
                style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            >
                {maskData.loading ? (
                    <Loading
                        style={{ width: 100, height: 100 }}
                        tip={isUndefined(maskData.text) ? $t((v) => v.globalMask.loading) : maskData.text}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(MaskLoading);
